<app-picker
  #_pickerComponent
  (pickerDialogAfterClosedEvent)="pickerDialogAfterClosedEventHandler()"
  (selectElement)="selectElement($event)"
  (updateState)="updateState($event)"
  (uuidSelected)="uuidSelectedHandler($event)"
  [addButtonLabel]="'Changer de compte'"
  [addIconButtonTooltip]="'Sélectionner un compte'"
  [autoCompleteResultList]="autoCompleteResultList"
  [elements]="elements"
  [existenceFlag]="existenceFlag"
  [highlightCol1GroupFlag]="true"
  [highlightCol1InfoFlag]="true"
  [highlightCol1LabelFlag]="true"
  [loadedFlag]="loadedFlag"
  [matLabel]="'Saisir un compte'"
  [multipleSelectionFlag]="false"
  [showInputFlag]="false"
  [state]="pickerState"
  [textFilterDefaultValue]="textFilterDefaultValue"
  [totalCount]="totalCount"
></app-picker>
